"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ssrService;
/**
 * get SSR helpers
 * @return {Object} SSR helpers
 */
function ssrService() {
  return {
    /**
     * @description Return True If Client Side Render
     * @returns {boolean}
     */
    isCSR: function isCSR() {
      return typeof window !== 'undefined';
    }
  };
}